import AsyncStorage from '@react-native-async-storage/async-storage';

function makePref(key: string) {
  return {
    async get(): Promise<string | null> {
      try {
        return await AsyncStorage.getItem(key);
      } catch {
        return null;
      }
    },
    async set(value: string): Promise<void> {
      try {
        await AsyncStorage.setItem(key, value);
      } catch {
        // ignore
      }
    },
    async clear(): Promise<void> {
      try {
        await AsyncStorage.removeItem(key);
      } catch {
        // ignore
      }
    },
  };
}

const lastBranchId = makePref('kiosc_last_selected_branch_id');
const posPaymentMethod = makePref('@vuelto/pos_last_payment_method_id');
const kitchenAutoPrint = makePref('@vuelto/kitchen_auto_print_enabled');
const kitchenKioskMode = makePref('@vuelto/kitchen_kiosk_mode');
const kitchenDensity = makePref('@vuelto/kitchen_density');
const kitchenScreenRole = makePref('@vuelto/kitchen_screen_role');
const stationPrinters = makePref('@vuelto/kitchen_station_printers');
const counterReadySound = makePref('@vuelto/counter_ready_sound_enabled');

export const getLastSelectedBranchId = lastBranchId.get;
export const setLastSelectedBranchId = lastBranchId.set;
export const clearLastSelectedBranchId = lastBranchId.clear;

export const getLastPosPaymentMethodId = posPaymentMethod.get;
export async function setLastPosPaymentMethodId(methodId: string | null | undefined): Promise<void> {
  if (!methodId) return;
  await posPaymentMethod.set(methodId);
}

export const getKitchenAutoPrint = kitchenAutoPrint.get;
export const setKitchenAutoPrint = kitchenAutoPrint.set;

export const getKitchenKioskMode = kitchenKioskMode.get;
export const setKitchenKioskMode = kitchenKioskMode.set;
export const getKitchenDensity = kitchenDensity.get;
export const setKitchenDensity = kitchenDensity.set;
export const getKitchenScreenRole = kitchenScreenRole.get;
export const setKitchenScreenRole = kitchenScreenRole.set;

export async function getStationPrinters(): Promise<Record<string, string>> {
  const raw = await stationPrinters.get();
  if (!raw) return {};
  try {
    return JSON.parse(raw) as Record<string, string>;
  } catch {
    return {};
  }
}

export async function setStationPrinters(map: Record<string, string>): Promise<void> {
  await stationPrinters.set(JSON.stringify(map));
}

/** Sonido en mostrador cuando un pedido pasa a listo (default ON). */
export const getCounterReadySoundEnabled = counterReadySound.get;
export const setCounterReadySoundEnabled = counterReadySound.set;
